require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconBolt.tsx
var IconBolt_exports = {};
__export(IconBolt_exports, {
  default: () => IconBolt_default
});
module.exports = __toCommonJS(IconBolt_exports);

// src/assets/monochrome/bolt.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgBolt = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M9.3258 12.2592H9.14081C7.98206 12.2592 6.82345 12.2592 5.66496 12.2592C5.31072 12.2592 5.05646 12.0023 5.00608 11.6025C4.97971 11.3932 5.04229 11.2117 5.13242 11.0368C5.89128 9.55957 6.64921 8.08329 7.40623 6.60797C8.29497 4.87618 9.18384 3.14471 10.0728 1.41355C10.2531 1.06232 10.5432 0.923245 10.8368 1.04111C10.9732 1.09576 11.0897 1.20488 11.1669 1.3502C11.244 1.49551 11.2772 1.66818 11.2607 1.83927C11.082 3.48242 10.902 5.12511 10.7207 6.76733C10.6861 7.08603 10.653 7.4052 10.6172 7.74322H10.7896C11.9582 7.74322 13.1264 7.74558 14.2946 7.74087C14.5614 7.74087 14.7795 7.83799 14.9157 8.12086C15.0518 8.40373 15.0133 8.6899 14.8704 8.96947C13.2257 12.1719 11.5827 15.3757 9.94138 18.5809C9.80126 18.8543 9.60958 19.0137 9.33879 18.9991C9.09318 18.9854 8.90583 18.8378 8.80861 18.5677C8.7613 18.4339 8.74211 18.2882 8.75272 18.1434C8.92039 16.3623 9.09673 14.583 9.27109 12.8028C9.28801 12.6251 9.30651 12.4511 9.3258 12.2592ZM10.3354 14.8701L10.3594 14.8838C11.3174 13.0164 12.275 11.1485 13.2484 9.25092H11.352C10.8797 9.25092 10.4098 9.25469 9.93863 9.25092C9.52102 9.2462 9.22543 8.86857 9.27502 8.40231C9.35374 7.64799 9.44112 6.8998 9.52338 6.14831C9.55684 5.8447 9.58754 5.54015 9.61982 5.23606L9.59187 5.22522L6.75522 10.7515H6.94454C7.95569 10.7515 8.96684 10.7515 9.97799 10.7515C10.4192 10.7515 10.6821 11.0924 10.6522 11.6171C10.6432 11.7755 10.6239 11.9325 10.6085 12.0886C10.5177 13.0164 10.4267 13.9436 10.3354 14.8701Z", fill: "#676F7E" }) });
var bolt_default = SvgBolt;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconBolt.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconBolt = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(bolt_default, {}) });
};
IconBolt.displayName = "IconBolt";
var IconBolt_default = IconBolt;
